module.exports = __webpack_public_path__ + "static/media/pk_relay.6a60cd9d.jpg";